define('modules/auth/models/signup.contact.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(_, Backbone, BaseModel){
    var SignUpModel = BaseModel.extend({
        base : 'v1/authentication/contact',
        serviceRoot:'nerds/',
        requiresSpecifiedHost: false,
        parse: function(response) {
            if (typeof response.id != "undefined") {
                window.user.set(response);
            }
            return response;
        },
    });
    return SignUpModel;
});


